<template>
    <div>
        <div class="error" @click="closeIfream">
            <i class="el-icon-error"></i>
        </div>
        <iframe v-if="itemData.length === undefined" :src="itemData.url" frameborder="0"></iframe>
        <div v-else>

            <div style="width: 200px;position: absolute;bottom: 100px;left: 100px;z-index: 1;">
                <div style="height: 40px;margin-top: 10px" v-for="( liItem, index ) in itemData"  @click="handle(liItem,index)">
                    <el-button style="position: absolute;z-index: 2;" type="primary">{{liItem.name}}</el-button>
                </div>
                <div v-for="( liItems, index ) in itemData">
                    <iframe  v-if="acitveIndex === index" :src="modelUrl" frameborder="0"></iframe>
                </div>
            </div>
        </div>
        <div style="position: absolute;right: 20px;top: 50%">
            <el-button type="primary" @click="itemData.url ='https://e.modocker.com/link/?id=ET3319R5m7X5x38Mkce0TbB5Om9dHfe3&preload=1&logo=0&toolbar=0&rotation=0'">切换</el-button>
        </div>
    </div>
</template>

<script>
    import ModelViewer from '../../components/3D/ModelViewer.vue'
    export default {
        props: ['itemData'],

        name: "index",
        components:{
            ModelViewer
        },
        data() {
            return {
                acitveIndex:0,
                modelUrl:'http://uav.cnuvr.cn/uavx/' + '#/webglTest?model3D=' + 'z71Lc281UVryH08vvqug8fwTS3GV91Dg',//默认是阳光明媚
            }
        },

        methods:{
            handleLoaded(){
                scene.moSpecial.cameraSettings({ left: 120, right:120, up: 80, down: 80, in: 0, out:0});
            },
            //天气点击事件按钮
            handle(item,index){
                this.acitveIndex = index
                this.modelUrl = 'http://uav.cnuvr.cn/uavx/'+ '#/webglTest?model3D=' + item.dir_name
            },
            closeIfream(){
                this.$emit('closeIfream',false)
            }

        },

        watch:{
            itemData(){
                console.log(this.itemData);
            }
        }
    }
</script>

<style scoped>
    iframe {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom:0;
    }
    .error{
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
        top: 0;
        position: absolute;
        right: 0;
        height: 100px;
        width: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/components/iframe/index.vue